import { FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
// this class is used to show the error state of a form field ONLY when the form is submitted, not earlier.
export class ShowOnSubmitErrorStateMatcher implements ErrorStateMatcher {
  static submitted = false;

  isErrorState(
    control: any | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    return !!(
      control &&
      control.invalid &&
      ShowOnSubmitErrorStateMatcher.submitted
    );
  }

  static reset() {
    this.submitted = false;
  }
}
